import SnackbarMobile from '@tencent/dui-mobile/lib/components/Snackbar';
import debounce from 'lodash/debounce';
import i18n from '@i18next/i18n';
import tdocsBridge from '@src/slide/infrastructure/module/independent/tdocsBridge/tdocsBridge';

enum ChooseImageRetCode {
    SUCCESS = 0,
    NO_PERMISSION = 1,
    FAIL = 2,
    CANCEL = 3,
}

interface IImageProps {
    src: number;
    width: number;
    height: number;
}

type ISelectCallback = (images: Array<IImageProps> | null, error: number) => void;

export default class NativeSelectImage {
    public static selectImage = debounce((callback: ISelectCallback) => {
        tdocsBridge.tdocs?.chooseImage?.({
            max_count: 9,
            success: (dataMap) => {
                NativeSelectImage.chooseImageCallback(dataMap, callback);
            },
            fail: NativeSelectImage.chooseImageFail,
        });
    }, 1000);

    public static chooseImageCallback = (dataMap: any, callback: ISelectCallback) => {
        const { imgList } = dataMap;
        // 企微返回的是上传后的图片链接
        if (imgList) {
            callback(NativeSelectImage.urlListToImagePropsList(imgList), ChooseImageRetCode.SUCCESS);
        } else {
            callback(null, ChooseImageRetCode.FAIL);
        }
    };

    private static chooseImageFail(err: any, code: number) {
        switch (code) {
            case ChooseImageRetCode.NO_PERMISSION:
                SnackbarMobile.show({
                    message: i18n.t('无相册权限，请在系统设置开启。'),
                    duration: 3000,
                    autoClose: true,
                });
                break;
            case ChooseImageRetCode.FAIL:
                SnackbarMobile.show({
                    message: i18n.t('图片上传失败，请重试。'),
                    duration: 3000,
                    autoClose: true,
                });
                break;
            default:
                break;
        }
    }

    private static urlListToImagePropsList = urlList => urlList.map(urlInfo => ({
        src: NativeSelectImage.formatImageSrc(urlInfo.url, urlInfo.type, urlInfo.width, urlInfo.height),
        width: urlInfo.width,
        height: urlInfo.height,
    }));

    private static formatImageSrc(
        imageSrc: string,
        imageType: undefined | null | string,
        width: number | string,
        height: number | string,
    ) {
        const query = `w=${width}&h=${height}&_type=${imageType}`;
        const sep = imageSrc.includes('?') ? '&' : '?';
        return `${imageSrc}${sep}${query}`;
    }
}
